import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Category as SchemaCategory } from '../schemas/Category';
import { type Error as SchemaError } from '../schemas/Error';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Categories
 */
export const GetCategoryContentType = '' as const;
export type GetCategoryRequest = void;
export type GetCategoryResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of data
     */
    '200': {
        'application/json': SchemaCategory;
    };
    /**
     * @description Not found
     */
    '404': {
        'application/json': SchemaError;
    };
};
export type GetCategoryResponseSuccess = GetCategoryResponses['200']['application/json'];
export type GetCategorySearchParams = undefined;
export type GetCategoryPathParameters = {
    id: string;
};
export const GetCategoryUrl = '/categories/{id}' as const;
export const GetCategoryMethod = 'GET' as const;
export const getGetCategoryUrl = (params: GetCategoryPathParameters) =>
    GetCategoryUrl.replace(/\{(\w+)\}/g, (_match, param: keyof GetCategoryPathParameters) => String(params[param]));
